// extracted by mini-css-extract-plugin
module.exports = {"rotation":"ContattiTemplate_rotation__VT0b2"};